export default __webpack_public_path__ + "static/media/icon_category-bride.1887d011.svg";